// extracted by mini-css-extract-plugin
module.exports = {"Container":"CookiesModal_Container__3t35b","Text":"CookiesModal_Text__3VtBj","Close":"CookiesModal_Close__o5UFz"};